export default __webpack_public_path__ + "static/media/bedroom-icon.b02de799.svg";